import React from "react";
import {Col, Row} from "react-bootstrap";
import {UserDashboardRefundCardComponent} from "@Pages/@@UserPages/@Dashboard/Cards";
import attachMoneyIcon from "@Icons/SVG/icon-attach_money-s-yellow.svg";
import showChartIcon from "@Icons/SVG/icon-show_chart-s-orange.svg";
import accessTimeIcon from "@Icons/SVG/icon-access_time-s-orange.svg";
import checkIcon from "@Icons/SVG/icon-check-s-orange.svg";
import UserDashboardSecurityCardComponent from "../Cards/SecurityCard";
import radioButtunIcon from "@Icons/SVG/icon-radio_button_checked-s-orange.svg";
import securityIcon from "@Icons/SVG/icon-security-s-orange.svg";
import syncIcon from "@Icons/SVG/icon-sync-s-orange.svg";
import languageIcon from "@Icons/SVG/icon-language-s-orange.svg";
import {SvgIconComponent} from "@Components/Elements";
import uploadFileIcon from "@Icons/SVG/icon-upload_file-s-white.svg";
import checkCircleIcon from "@Icons/SVG/icon-check_circle_outline-s-green.svg";
import extraActionsIcon from "@Icons/SVG/icon-extra_action-s-grey.svg";
import accessTimeBlueIcon from "@Icons/SVG/icon-access_time-s-blue.svg";
import {ButtonComponent} from "@Components/Forms";
import uploadIcon from "@Icons/SVG/icon-file_upload-m-black.svg";
import downloadIcon from "@Icons/SVG/icon-download-s-white.svg";
import {SectionContainerComponent} from "@Components/Sections";


export const UserDashboardHomePage:React.FC = () => {

    return (
        <SectionContainerComponent
            id={'user-dashboard-page__user-dashboard'}
        >

            <Col xs={12} className={'user-dashboard-header-component'}>
                <Row className={'user-dashboard-header-component__content'}>
                    <Col xs={12} className={'user-dashboard-header-component__header-text'}>
                        <span>Your Refund Dashboard</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-header-component__header-description'}>
                        <span>C.A.R.E. is working 24/7 to find money you're owed</span>
                    </Col>
                </Row>
            </Col>

            <Col xs={12} className={'user-dashboard-section-component'}>
                <Row className={'user-dashboard-section-component__content'}>
                    <Col xs={12} className={'user-dashboard-section-component__cards-list'}>
                        <Row className={'user-dashboard-section-component__cards-list__content'}>
                            <UserDashboardRefundCardComponent
                                cardIcon={attachMoneyIcon}
                                cardType={'special'}
                                cardTitle={'Total Recovered'}
                                cardContent={'$1,247.50'}
                                cardDescription={'+$89.25 this month'}
                            />
                            <UserDashboardRefundCardComponent
                                cardIcon={showChartIcon}
                                cardTitle={'Active Claims'}
                                cardContent={'7'}
                                cardDescription={'3 filed, 4 in progress'}
                            />
                            <UserDashboardRefundCardComponent
                                cardIcon={accessTimeIcon}
                                cardTitle={'Avg. Processing'}
                                cardContent={'12 days'}
                                cardDescription={'Faster than industry avg'}
                            />
                            <UserDashboardRefundCardComponent
                                cardIcon={checkIcon}
                                cardTitle={'Success Rate'}
                                cardContent={'94%'}
                                cardDescription={'Claims successfully filed'}
                            />
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xs={12} className={'user-dashboard-section-component'}>
                <Row className={'user-dashboard-section-component__content'}>
                    <Col xs={12} className={'user-dashboard-section-component__section-header'}>
                        <span>Security & Compliance Pillars</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-section-component__section-description'}>
                        <span>What each security measure means for you</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-section-component__cards-list'}>
                        <Row className={'user-dashboard-section-component__cards-list__content'}>
                            <UserDashboardSecurityCardComponent
                                cardIcon={radioButtunIcon}
                                cardTitle={'Scanning Active'}
                                cardDescription={'Last scan: 2 min ago'}
                            />
                            <UserDashboardSecurityCardComponent
                                cardIcon={securityIcon}
                                cardTitle={'Secure Connection'}
                                cardDescription={'Read-only access'}
                            />
                            <UserDashboardSecurityCardComponent
                                cardIcon={syncIcon}
                                cardTitle={'AI Processing'}
                                cardDescription={'47,382 emails analyzed'}
                            />
                            <UserDashboardSecurityCardComponent
                                cardIcon={languageIcon}
                                cardTitle={'Global Coverage'}
                                cardDescription={'200+ companies tracked'}
                            />
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xs={12} className={'user-dashboard-section-component'}>
                <Row className={'user-dashboard-section-component__content'}>
                    <Col xs={12} className={'user-dashboard-section-component__section-header'}>
                        <span>Claims Management</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-section-component__section-description'}>
                        <span>Track your refund claims and their progress</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-section-component__claims-list'}>
                        <Row className={'user-dashboard-section-component__claims-list'}>
                            <Col xs={12} className={'user-dashboard-section-component__claims-list__list-header'}>
                                <Row className={'user-dashboard-section-component__claims-list__list-header__content'}>
                                    <Col xs={'auto'} className={'claim-list-item-type'}>
                                        <span>Type</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-detected-date'}>
                                        <span>Date Detected</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-refund-amount'}>
                                        <span>Refund Amount</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-status'}>
                                        <span>Status</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-qyvo-fee'}>
                                        <span>Qyvo Fee (25%)</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-user-payout'}>
                                        <span>Your Payout</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-actions'}>
                                        <span>Actions</span>
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'user-dashboard-section-component__claims-list__list-element'}>
                                <Row className={'user-dashboard-section-component__claims-list__list-element__content'}>
                                    <Col xs={'auto'} className={'claim-list-item-type'}>
                                        <SvgIconComponent iconSource={uploadFileIcon} className={'svg-icon-element'} />
                                        <span>Airline</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-detected-date'}>
                                        <span>Dec 15, 2024</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-refund-amount'}>
                                        <span>$180.00</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-status'}>
                                            <span className={'tooltip-status-component success-type'}>
                                                <SvgIconComponent iconSource={checkCircleIcon} className={'tooltip-status-component__status-icon'} />
                                                <span className={'tooltip-status-component__status-text'}>Paid</span>
                                            </span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-qyvo-fee'}>
                                        <span>$45.00</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-user-payout'}>
                                        <span>$135.00</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-actions'}>
                                        <SvgIconComponent iconSource={extraActionsIcon} className={'claim-list-item-actions__button'} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'user-dashboard-section-component__claims-list__list-element'}>
                                <Row className={'user-dashboard-section-component__claims-list__list-element__content'}>
                                    <Col xs={'auto'} className={'claim-list-item-type'}>
                                        <SvgIconComponent iconSource={uploadFileIcon} className={'svg-icon-element'} />
                                        <span>Subscription</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-detected-date'}>
                                        <span>Dec 12, 2024</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-refund-amount'}>
                                        <span>$89.99</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-status'}>
                                            <span className={'tooltip-status-component warning-type'}>
                                                <SvgIconComponent iconSource={attachMoneyIcon} className={'tooltip-status-component__status-icon'}/>
                                                <span className={'tooltip-status-component__status-text'}>Filled</span>
                                            </span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-qyvo-fee'}>
                                        <span>$22.50</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-user-payout'}>
                                        <span>$67.49</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-actions'}>
                                        <SvgIconComponent iconSource={extraActionsIcon} className={'claim-list-item-actions__button'} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={12} className={'user-dashboard-section-component__claims-list__list-element'}>
                                <Row className={'user-dashboard-section-component__claims-list__list-element__content'}>
                                    <Col xs={'auto'} className={'claim-list-item-type'}>
                                        <SvgIconComponent iconSource={uploadFileIcon} className={'svg-icon-element'} />
                                        <span>Hotel</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-detected-date'}>
                                        <span>Dec 10, 2024</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-refund-amount'}>
                                        <span>$245.00</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-status'}>
                                            <span className={'tooltip-status-component information-type'}>
                                                <SvgIconComponent iconSource={accessTimeBlueIcon} className={'tooltip-status-component__status-icon'}/>
                                                <span className={'tooltip-status-component__status-text'}>Waiting</span>
                                            </span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-qyvo-fee'}>
                                        <span>$61.25</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-user-payout'}>
                                        <span>$183.75</span>
                                    </Col>
                                    <Col xs={'auto'} className={'claim-list-item-actions'}>
                                        <SvgIconComponent iconSource={extraActionsIcon} className={'claim-list-item-actions__button'} />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

            <Col xs={12} className={'user-dashboard-section-component'}>
                <Row className={'user-dashboard-section-component__content'}>
                    <Col xs={12} className={'user-dashboard-section-component__section-header'}>
                        <span>Upload Options</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-section-component__section-description'}>
                        <span>Choose how you want to handle your refund claims</span>
                    </Col>
                    <Col xs={12} className={'user-dashboard-section-component__section-content'}>
                        <Row className={'user-dashboard-section-component__section-content__content'}>
                            <Col xs={6} className={'additional-information-component'}>
                                <Row className={'additional-information-component__content'}>
                                    <Col xs={12} className={'additional-information-component__additional-information-title'}>
                                        <span>Let Qyvo Handle Everything</span>
                                    </Col>
                                    <Col xs={12} className={'additional-information-component__additional-information-description'}>
                                        <span>We'll file your claims automatically and handle all communication with companies.</span>
                                    </Col>
                                    <Col xs={12} className={'additional-information-component__additional-information-content'}>
                                        <ButtonComponent
                                            text={'Upload documents'}
                                            iconLeft={uploadIcon}
                                            size={'l'}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <Col xs={6} className={'additional-information-component'}>
                                <Row className={'additional-information-component__content'}>
                                    <Col xs={12} className={'additional-information-component__additional-information-title'}>
                                        <span>Download Forms & Submit Yourself</span>
                                    </Col>
                                    <Col xs={12} className={'additional-information-component__additional-information-description'}>
                                        <span>Get pre-filled forms and submit them directly to companies on your own.</span>
                                    </Col>
                                    <Col xs={12} className={'additional-information-component__additional-information-content'}>
                                        <ButtonComponent
                                            text={'Download forms'}
                                            iconLeft={downloadIcon}
                                            type={'secondary'}
                                            size={'l'}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>

        </SectionContainerComponent>
    );

};


export default UserDashboardHomePage;
